import { ATRCalculation } from '../indicator-calculation/atr'
import { drawInVisibleArea } from '../utils/draw_in_visible_area'
import { ATRConfig, Attrs } from './configs/atr'
import Indicator from './indicator'

class ATR extends Indicator<Attrs> {
  static config = ATRConfig

  declare atrCalculation: ATRCalculation
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary() || this.atrCalculation === null) {
      this.atrCalculation = new ATRCalculation({
        quote: this.data,
        options: { period: this.period },
      })

      this.atrCalculation.calculate()
      this.lastValue = this.atrCalculation.calculatedValues.atr.last() ?? null
    }
    const { min, max } =
      this.atrCalculation.calculatedValues.atr.length > 0
        ? this.computeVisibleMinMax(this.atrCalculation.calculatedValues.atr)
        : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  getValueLabelsAtIndex(index: number) {
    const dataIndex = this.data.barToDataIndex[index]
    return [
      {
        color: this.getChartLayoutSettings().IndicatorSettings.general.Colors.line!,
        text: this.getValueLabel(this.atrCalculation.calculatedValues.atr[dataIndex]),
      },
    ]
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    context.set('strokeStyle', this.getChartLayoutSettings().IndicatorSettings.general.Colors.line)
    context.translate(0.5, 0.5)
    context.beginPath()
    drawInVisibleArea({
      quote: this.data,
      paneModel: this.model,
      leftOffset: this.leftOffset,
      width: this.width,
      drawBarCallback: (i: number, x: number) => {
        context.lineTo(x, Math.round(this.fy(this.atrCalculation.calculatedValues.atr[i])))
      },
    })
    context.stroke()
    context.translate(-0.5, -0.5)
  }

  getModalConfig() {
    const options = {
      period: {
        type: 'number',
        label: 'Period',
        name: 'period',
        value: this.period ?? 14,
        required: true,
        min: 1,
        max: 999999,
      },
    }

    return {
      title: ATRConfig.label,
      inputs: ATRConfig.inputsOrder.map((item) => options[item]),
      inputsErrorMessages: {
        period: `${options.period.label} must be a whole number between ${options.period.min} and ${options.period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }
}

export default ATR
